import queryString from 'query-string';
import * as actionTypes from './types';
import * as api from '../../api/base';
import { endpoints } from '../../api/endpoints';
import {
  storeCommon,
  dfltSuccessResponseAction,
  dfltFailResponseAction,
  dfltExceptionResponseAction
} from '../utility'



export const getAllReports = (params) => async (dispatch) => {
  try {
    const response = await api.get(endpoints.farm.reports.concat(params.farmId ? '?' + queryString.stringify(params) : '/all'));
    if (response && response.status === 200) {
      return dispatch(getAllReportsSuccess(response?.data));
    }
    else
      return dispatch(getAllReportsFail(response?.data?.error?.message || storeCommon.defaultErrorMessage));
  } catch (error) {
    return dispatch(getAllReportsFail(error?.message || storeCommon.defaultErrorMessage));
  }
};

export const clearAllReportsData = (response) => {
  return {
    type: actionTypes.CLEAR_ALL_REPORTS_DATA,
    payload: response
  };
};

const getAllReportsSuccess = (response) => {
  return {
    type: actionTypes.GET_ALL_REPORTS_SUCCESS,
    payload: response
  };
};
const getAllReportsFail = (response) => {
  return {
    type: actionTypes.GET_ALL_REPORTS_FAIL,
    payload: response
  };
};

export const copyReport = ({ reportId, title }) => async (dispatch) => {
  try {
    const response = await api.get(endpoints.farm.report.concat(`/${reportId}/copy?name=${title}`));
    if (response && (response.status === 200 || response.status === 204)) {
      return dispatch(dfltSuccessResponseAction(response.data || "The Report has been successfully cloned"));
    }
    else {
      return dispatch(dfltFailResponseAction(response));
    }
  } catch (error) {
    return dispatch(dfltExceptionResponseAction(error));
  }
};

export const deleteReport = (reportId) => async (dispatch) => {
  try {
    const response = await api.del(endpoints.farm.report.concat('?reportId=', reportId));
    if (response && (response.status === 200 || response.status === 204)) {
      return dispatch(dfltSuccessResponseAction(response.data || "The Report has been successfully deleted"));
    }
    else {
      return dispatch(dfltFailResponseAction(response));
    }
  } catch (error) {
    return dispatch(dfltExceptionResponseAction(error));
  }
};

export const submitStatusReport = ({ reportId, statusId }) => async (dispatch) => {
  try {
    const response = await api.get(endpoints.farm.reportStatus.replace('REPORT_ID', reportId).replace('STATUS_ID', statusId));
    if (response && (response.status === 200 || response.status === 204)) {
      return dispatch(dfltSuccessResponseAction(response.data || "The report has been mark as reviewed."));
    }
    else {
      return dispatch(dfltFailResponseAction(response));
    }
  } catch (error) {
    return dispatch(dfltExceptionResponseAction(error));
  }
};

